import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { Avatar, InputNumber } from "antd";
import "./CartButton.scss";

const CartButton = ({ count, setCount, handleCount }: any) => {
  return (
    <div className="Cart-Button-Box">
      <button
        onClick={() => {
          if (count > 0) {
            setCount(count - 1);
          }
        }}
        className="Cart-Button-Minus"
        disabled={count === 0}
      >
        <MinusOutlined className="Cart-Button-Icon" />
      </button>
      <div className="Cart-Button-Box-Input">{count}</div>
      <button onClick={() => setCount(count + 1)} className="Cart-Button-Plus">
        <PlusOutlined className="Cart-Button-Icon" />
      </button>
    </div>
  );
};
export default CartButton;
